import { render, staticRenderFns } from "./shangping_tianjia.vue?vue&type=template&id=68c883c6&"
import script from "./shangping_tianjia.vue?vue&type=script&lang=js&"
export * from "./shangping_tianjia.vue?vue&type=script&lang=js&"
import style0 from "./shangping_tianjia.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports